<template>
    <div>
        <div class="level">
            <p class="level-item"><strong>{{this.graphname}}</strong></p>
        </div>
        <graph :plotdata="this.plotdata"></graph>
    </div>
</template>

<script>
import Graph from '../view/Graph'
import moment from 'moment'
    export default {
        components: {
            Graph
        },
        data() {
            return {
                plotdata: [],
                graphname: ""
            }
        },
        mounted() {
            window.addEventListener('message', (ev) => {
                if (ev.type === "message") {
                    const data = ev.data
                    this.graphname = data.n
                    this.plotdata.push({x: moment().format(), y: data.v})
                }
            })
        }
    }
</script>
